import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

/**
 * Claro por omissão, e não "system".
 *
 * O produto é para ler — prosa longa, tabelas densas, fac-símiles. `system`
 * fazia a primeira visita depender da hora a que alguém configurou o portátil,
 * e metade das pessoas via um acervo de manuscritos em fundo preto. Quem
 * prefere escuro continua a ter o interruptor, e a escolha fica guardada.
 */

interface SessionState {
  readonly theme: Theme;
  readonly listMode: boolean;
  readonly lastViewed: readonly string[];
  setTheme(theme: Theme): void;
  setListMode(on: boolean): void;
  noteViewed(id: string): void;
}

/**
 * So o que **nao** pertence a URL. Filtros e posicao de investigacao vivem
 * nos search params ([lib/filters.ts]); aqui ficam preferencias do proprio
 * dispositivo.
 */
export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      theme: 'light',
      listMode: false,
      lastViewed: [],
      setTheme: (theme) => set({ theme }),
      setListMode: (listMode) => set({ listMode }),
      noteViewed: (id) => set((s) => ({ lastViewed: [id, ...s.lastViewed.filter((x) => x !== id)].slice(0, 20) })),
    }),
    { name: 'et-session' },
  ),
);

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
}
